import axios from "@/counsel-axios";

const BASE_URL = "/counsel/migration/afterdoc";

/**
 * multipart/form-data 조립.
 * counsel-api 는 파일을 통째로 받아 서버측에서 파싱한다 (브라우저 파싱 없음).
 * - file      : data-store.json 원본 File
 * - companyId : 대상 병원 id (admin 은 크로스 컴퍼니라 명시적으로 실어 보낸다)
 */
function buildForm(companyId, file) {
  const form = new FormData();
  form.append("file", file);
  form.append("companyId", companyId);
  return form;
}

export const counselMigrationApi = {
  // 서버측 드라이런: 파일을 올려 이관 계획 요약만 받는다 (적재 없음).
  // -> { summary, items, sample[] }
  preview(companyId, file) {
    return axios.post(`${BASE_URL}/preview`, buildForm(companyId, file));
  },

  // 실제 적재: 같은 파일을 올려 EndUser/상담방/메시지를 생성한다 (멱등 — 중복은 서버가 건너뜀).
  // -> { summary, applied }
  apply(companyId, file) {
    return axios.post(`${BASE_URL}/apply`, buildForm(companyId, file));
  },
};

// 제외 사유 표기 (summary.excluded 키 -> 한글). 미매핑 키는 원문 그대로 노출한다.
export const EXCLUDED_REASON_LABEL_MAP = {
  "방 id 없음": "방 id 없음",
  "afterdoc 전용 앱": "afterdoc 전용 앱",
  "채널/식별자 없음": "채널/식별자 없음",
  "메시지 0건": "메시지 0건",
};
